export const PAYMENT_METHOD_NOT_SUPPORTED =
  "No selected investment accounts accept this payment method.";
export const PAYMENT_METHOD_PARTIALLY_SUPPORTED =
  "This payment method is not accepted by some of the selected investments. " +
  "You can apply this method to the investments that accept it.";
